// extracted by mini-css-extract-plugin
export var card = "_8f-1";
export var container = "_8f-0";